const BgVideos = () => {
    const videoUrls = ['https://www.youtube.com/embed/dKVk2Q0IFZQ?si=g6lMmVNtcAwe9kJR', 'https://www.youtube.com/embed/TVAc2S_xxLo?si=pN-gq3mCEioI7HL_', 'https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fmckeownautoservice%2Fvideos%2F365492129951812%2F&show_text=false&width=560&t=0'];
    const videoTitles = ['BG EPR, Engine Performance Restorer Demo at McKeown Auto Services', 'Car Servicing at McKeown Auto Services', 'Diesel Oil Conditioner demo at McKeown Autos'];

    const getVideos = () => {
        let videoObjects = [];

        for (let index = 0; index < videoUrls.length; index++) {

            console.log(videoUrls[index])
            let url = videoUrls[index];
            let title = videoTitles[index];
            videoObjects.push(
                <iframe width="560" height="315" src={url} title={title} frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            )
        }

        return videoObjects;
    }

    return (getVideos())
}

export default BgVideos;